import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { Modal } from 'react-bootstrap';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import {
	BS_TEST,
	LA_TEST,
	RR_TEST,
	LF_TEST,
} from '../../constants.js';
import s from './Step2a.css';

library.add(faInfoCircle);

class Step2a extends PureComponent {

	constructor(props) {
		super(props);
		this.state = {
			modalToShow: '',
		};
	}

	handleCloseModal = () => {
		this.setState({ modalToShow: '' });
	};

	handleOpenModal = (name) => {
		this.setState({ modalToShow: name });
	};

	getLastTestResult(test, results) {
		if (results) {
			const sortedResults = results.filter((result) => result.name === test);
			if (sortedResults.length > 0) {
				return sortedResults[sortedResults.length - 1];
			}
			return null;
		} else {
			return null;
		}
	}

	getDescription(result) {
		if (result) {
			return result.result;
		} else {
			return '';
		}
	}

	render() {
		const {
			modalToShow,
		} = this.state;

		const {
			client,
		} = this.props;

		const LA = this.getLastTestResult(LA_TEST, client.results);
		const RR = this.getLastTestResult(RR_TEST, client.results);
		const BS = this.getLastTestResult(BS_TEST, client.results);
		const LF = this.getLastTestResult(LF_TEST, client.results);

		return (
			<React.Fragment>
				<div className="row" style={{ marginTop: '0px' }}>
					<div className={`col-md-12`}>
						{ LA && RR && BS && LF &&
						<div className={s.header}>Use the behavioral finance assessment results below to complete {client.firstName}'s profile</div>
						}
						{ (!LA || !RR || !BS || !LF) &&
						<div className={s.header}>We highly recommend completing the behavioral finance assessment in Step 1</div>
						}
					</div>
				</div>
				{ LA &&
				<div className="row" style={{ marginTop: '30px' }}>
					<div className={`col-md-12`}>
						<div className={s.textBox}>
							<span style={{ fontSize: '26px', lineHeight: '46px' }}>{this.getDescription(LA).replace('your client', client.firstName)}</span>
							<FontAwesomeIcon
								style={{ color: '#5060f6', marginLeft: '2px', cursor: 'pointer' }}
								data-tip data-for={'LA'}
								icon="info-circle"
								size="sm"
								onClick={() => this.handleOpenModal('LA')}
							/>
							<ReactTooltip id={'LA'} type='light' className="clienttip" effect="float">
								Click for additional information<br />about the research.
						</ReactTooltip>
						</div>
					</div>
				</div>
				}
				{ (BS || RR || LF) &&
				<div className="row" style={{ marginTop: '2px' }}>
					<div className={`col-md-4`} style={{ paddingRight: '2px' }}>
						{ BS &&
						<div className={s.textBox}>
							{this.getDescription(BS).replace('your client', client.firstName)}
							<FontAwesomeIcon
								style={{ color: '#5060f6', marginLeft: '2px', cursor: 'pointer' }}
								data-tip data-for={'BS'}
								icon="info-circle"
								size="sm"
								onClick={() => this.handleOpenModal('BS')}
							/>
							<ReactTooltip id={'BS'} type='light' className="clienttip" effect="float">
								Click for additional information<br />about the research.
              				</ReactTooltip>
						</div>
						}
					</div>
					<div className={`col-md-4`} style={{ paddingLeft: '1px', paddingRight: '1px' }}>
						{ RR &&
						<div className={s.textBox}>
							{this.getDescription(RR).replace('your client', client.firstName)}
							<FontAwesomeIcon
								style={{ color: '#5060f6', marginLeft: '2px', cursor: 'pointer' }}
								data-tip data-for={'RR'}
								icon="info-circle"
								size="sm"
								onClick={() => this.handleOpenModal('RR')}
							/>
							<ReactTooltip id={'RR'} type='light' className="clienttip" effect="float">
								Click for additional information<br />about the research.
              				</ReactTooltip>
						</div>
						}
					</div>
					<div className={`col-md-4`} style={{ paddingLeft: '1px' }}>
						{ LF &&
						<div className={s.textBox}>
							{this.getDescription(LF).replace('your client', client.firstName)}
							<FontAwesomeIcon
								style={{ color: '#5060f6', marginLeft: '2px', cursor: 'pointer' }}
								data-tip
								data-for={'LF'}
								icon="info-circle"
								size="sm"
								onClick={() => this.handleOpenModal('LF')}
							/>
							<ReactTooltip id={'LF'} type='light' className="clienttip" effect="float">
								Click for additional information<br />about the research.
              				</ReactTooltip>
						</div>
						}
					</div>
				</div>
				}
				<Modal show={modalToShow === 'LA'} onHide={this.handleClose}>
					<Modal.Header>
						<Modal.Title><span style={{ fontWeight: '400' }}>Loss Aversion Calculator</span></Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<p>The loss aversion assessment is based on having the user work through a series of ten
						choice scenarios, where in each case they must choose between two pairs of small stakes
						gambles (i.e., one gain seeking and one loss averse gamble) each with three equally
						possible outcomes consisting of a gain, neutral, or loss payout. Each choice scenario
						is associated with loss aversion sensitivity score which is ratio of the marginal
						difference of the gains between the gambles to the marginal difference of the losses between
						the gambles. For example, suppose a choice scenario consists of two gambles where the gain
						seeking gamble has three equally possible outcomes of winning $500, neither winning nor losing
						money, or losing $300 ; and the loss averse gamble has three equally possible outcomes of winning
						$100, neither winning nor losing money, or losing $100. The marginal difference of the gains
						between the gambles is $400, and the marginal difference of the losses between the gambles is
						$200. Hence, this choice scenario is associated with loss aversion sensitivity score
						of $400/$200 = 2.0. A user’s loss sensitivity score is based on an estimation which
						averages i) the lowest observed loss aversion sensitivity score based on a user’s
						consistent choices of gain seeking gambles, and ii) the highest observed loss aversion
						sensitivity score based on a user’s consistent choices of loss averse gambles. The choice
							scenarios and sensitivity scores are bracketed to be between 0.5 and 10.0.</p>
						<p style={{ fontStyle: 'italic' }}>For more information on the scientific studies related to this assessment, see:</p>
						<ul>
							<li style={{ fontStyle: 'italic' }}>
								“The Personalized Portfolio: A Tool That Measures How Investors Feel About Losses
								Before They Lose Money.” WisdomTree Investments, Inc. (2018).
							</li>
							<li style={{ fontStyle: 'italic' }}>The tool implementation is covered by U.S.
							Patent No. 10,818,137, “Systems and Methods for Providing Customized Financial
							Advice Using Loss Aversion Assessments”.
							</li>
						</ul>
					</Modal.Body>
					<Modal.Footer>
						<div className={s.closeButton} onClick={this.handleCloseModal}>DONE</div>
					</Modal.Footer>
				</Modal>

				<Modal show={modalToShow === 'RR'} onHide={this.handleClose}>
					<Modal.Header>
						<Modal.Title><span style={{ fontWeight: '400' }}>Present Bias Assessment</span></Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<p>The assessment includes three pairs of questions which highlight the degree to
						which a person exhibits present bias (using 18-month delays) relative to discount
						rates of 3%, 10%, 30% (over 10 months). Namely, a user that makes inconsistent choices
						between present and future scenarios exhibits behavioral inconsistencies in their required
						discount rates required based on timing (and not just time interval for payouts/rewards).
						Evidence suggests that present bias individual behavioral difference is correlated with
						the propensity to regret retirement.  Users can exhibit from 0 to 3 inconsistencies,
							which are then labelled relatively to each other as either low, moderate, high, or very high risk.</p>
						<p style={{ fontStyle: 'italic' }}>For more information on the scientific studies related to this assessment, see:</p>
						<ul>
							<li style={{ fontStyle: 'italic' }}>“The Personalized Portfolio: Measuring Present Bias to
							Help Prevent Retirement Regret and Other Financial Mistakes.” WisdomTree Investments, Inc. (2019).</li>
						</ul>
					</Modal.Body>
					<Modal.Footer>
						<div className={s.closeButton} onClick={this.handleCloseModal}>DONE</div>
					</Modal.Footer>
				</Modal>

				<Modal show={modalToShow === 'BS'} onHide={this.handleClose}>
					<Modal.Header>
						<Modal.Title><span style={{ fontWeight: '400' }}>Behavioral Lifestyle Assessment</span></Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<p>According to the conventional wisdom, most people should aim to maintain roughly 70 percent
						of their income in retirement. While 70 percent is an adequate goal for some clients, it can
						lead many people to underestimate the amount of money that will keep them happy in retirement.
						This tool helps assess to what extent a person may have overlooked the emotional toll of
						cutting expenses in retirement through looking at the degree of their satisfaction between
						considering logically equivalent “keep” versus “cut” retirement income scenarios. The
						keep frame involves a reflection exercise of keeping 70 percent in retirement. The cut frame
						involves a reflection exercise of cutting 30 percent in retirement. The frames are logically
						equivalent, yet people make more holistic judgements by considering different perspectives.
						Users rate each of the scenarios using Likert scores from 1 to 7. Note that based on a 7-point
						scale, a 3-point gap between keep and cut frames is enough to change the valence of person’s
						rating (e.g., from extremely positive to neutral, from positive to negative). With that as
						context, if the gap between frames is greater than or equal to 3, then the baseline suggestion
						is for a person to plan to not cut their income after they retire (i.e., 100 percent retirement
						income). If the gap between frames is non-negative but less than 3 a financial goal of
						maintaining at least 90 percent of current income is suggested. If there is no gap between
							frames, then a goal of maintaining 70 or 80 percent of current income may work well for the user.</p>
						<p style={{ fontStyle: 'italic' }}>For more information on the scientific studies related to this assessment, see:</p>
						<ul>
							<li style={{ fontStyle: 'italic' }}>“Helping Clients Set the Right Spending Goal in Retirement.” WisdomTree Investments, Inc. (2020).</li>
						</ul>
					</Modal.Body>
					<Modal.Footer>
						<div className={s.closeButton} onClick={this.handleCloseModal}>DONE</div>
					</Modal.Footer>
				</Modal>

				<Modal show={modalToShow === 'LF'} onHide={this.handleClose}>
					<Modal.Header>
						<Modal.Title><span style={{ fontWeight: '400' }}>Mental Accounting of Losses Assessment</span></Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<p>Research shows that many investors are extremely sensitive to short-term losses,
						a phenomenon known as myopic loss aversion. If someone is myopic, they are nearsighted,
						meaning they can only properly focus on things that are close by and everything in the
						distance is blurry. When it comes to their investment performance, many investors are
						similarly nearsighted, only able to focus on recent events, even if it significantly
						reduces their long-term investment performance due to panic selling and suboptimal
						allocation of assets. Research finds that this phenomenon is shaped by the frequency of
						investor feedback, with more frequent feedback reducing the amount of risk that investors
						are willing to take. The assessment is based on five areas with each area getting equal
						weighting in the tool: 1) a measure of how often a person generally evaluates the performance
						of their investment portfolio, 2) a measure of anxiety felt during periods of market volatility
						or market downturns, 3) an indicator of whether a person uses any apps to regularly check on
						the performance of their investments, 4) a measure of to what extent a person is subject to
						narrow framing (over time) biases, and 5) measure of to what extent a person has behavioral
						grit and tends to stick to goals they set. Each question is scored from 1 to 5, and then a
							total is created with low risk (5 to 11 points), medium risk (12 to 18 points), and high risk (19 to 25 points).</p>
						<p style={{ fontStyle: 'italic' }}>For more information on the scientific studies related to this assessment, see:</p>
						<ul>
							<li style={{ fontStyle: 'italic' }}>Benartzi, S., & Thaler, R. H. (1995). Myopic loss aversion and the equity premium puzzle. The Quarterly Journal of Economics, 110(1), 73-92.</li>
							<li style={{ fontStyle: 'italic' }}>Duckworth, A. L., & Quinn, P. D. (2009). Development and validation of the Short Grit Scale (GRIT–S). Journal of personality assessment, 91(2), 166-174.</li>
							<li style={{ fontStyle: 'italic' }}>Haigh, M. S., & List, J. A. (2005). Do professional traders exhibit myopic loss aversion? An experimental analysis. The Journal of Finance, 60(1), 523-534.</li>
							<li style={{ fontStyle: 'italic' }}>Thaler, R. H., Tversky, A., Kahneman, D., & Schwartz, A. (1997). The effect of myopia and loss aversion on risk taking: An experimental test. The Quarterly Journal of Economics, 112(2), 647-661.</li>
							<li style={{ fontStyle: 'italic' }}>Ward, A. F., Duke, K., Gneezy, A., & Bos, M. W. (2017). Brain drain: The mere presence of one’s own smartphone reduces available cognitive capacity. Journal of the Association for Consumer Research, 2(2), 140-154.</li>
						</ul>
					</Modal.Body>
					<Modal.Footer>
						<div className={s.closeButton} onClick={this.handleCloseModal}>DONE</div>
					</Modal.Footer>
				</Modal>
			</React.Fragment>
		);
	}
}

function mapStateToProps() {
	return {};
}

export default connect(mapStateToProps, {
})(Step2a);




// WEBPACK FOOTER //
// ./src/components/AdvisorMode/Step2a.js